import '../../style/logo.scss'

const Logo = () => {
    return ( <div className="main_logo">
        <img src='/img/logo_main.svg' alt="Logo" />
    </div> );
}
 
export default Logo;